import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectIsAuthenticated = createSelector(selectAuthState, s => s.isAuthenticated);
export const selectCurrentUser     = createSelector(selectAuthState, s => s.user);
export const selectAuthToken       = createSelector(selectAuthState, s => s.token);
export const selectPermissions     = createSelector(selectAuthState, s => s.permissions);
export const selectLoginLoading    = createSelector(selectAuthState, s => s.loginLoading);
export const selectLoginError      = createSelector(selectAuthState, s => s.loginError);
